<template>
    <span class="slide-treatment-id">
        <patient-id :patient="selectedPatient" :vendor="instrumentType" />
        <span class="v-divider">|</span>

        <span
            v-b-tooltip.hover
            class="main-entity-id"
            :title="`${$utils.getTreatmentEsIdLabelByVendor(
                instrumentType
            )} ${treatmentEsIdByVendor}`"
        >
            {{ treatmentEsIdByVendor }}
        </span>
        <span class="v-divider">|</span>
        <span
            v-b-tooltip.hover
            class="main-entity-id"
            :title="`${$translate('slide')} ${$uiUtils.getVitrolifeSlideIdWithDescription(slide)}`"
        >
            {{ $uiUtils.getVitrolifeSlideIdWithDescription(slide) }}
        </span>
    </span>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { INSTRUMENT_TYPE } from '../../../business/const'
import PatientId from '../partials/PatientId'

export default {
    name: 'SlideTreatmentId',
    components: { PatientId },
    props: {
        slide: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapState({
            selectedPatient: state => state.timelapse.selectedPatient
        }),
        ...mapGetters({
            getSelectedInstrument: 'timelapse/getSelectedInstrument'
        }),
        instrument() {
            return this.getSelectedInstrument
        },
        instrumentType() {
            return this.slide.instrumentType
        },
        treatmentEsIdByVendor() {
            return this.$utils.getTreatmentEsIdByVendor(
                this.instrumentType,
                this.slide.esId,
                this.instrument.esId,
                this.slide.treatmentEsId || this.slide.treatment.esId
            )
        }
    }
}
</script>

<style lang="scss" scoped>
.slide-treatment-id {
    display: flex;
    align-items: center;

    .main-entity-id {
        text-align: left;
        @include trim();

        &.miri {
            max-width: 125px;
        }
    }

    .v-divider {
        margin: 0;
        border: none;
        padding: 0 0.25rem;
    }
}
</style>
